
























































































































































































































































































































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import { AppConstants as _app } from "@/shared/app.constants";
import HeaderInfo from '@/components/App/Modules/GMS/Admin/Dashboard/Components/HeaderInfo.vue';

@Component({
  components: {
    HeaderInfo
  }
})
export default class ReviewsComponent extends Vue {
  @Action("showNotification", { namespace: "application" }) notify: any;
  @Prop() tagReviews: any;
  @Prop() internalReview: any;
  @Prop() userid: any;
  @Prop() appInfo: any;
  @Prop() userType?: number;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  tagLockedStatus: any = [
    _app.reviewStatus.Submitted,
    _app.reviewStatus.COI_Rejected,
  ];
  gpouSubmittedStatus = _app.reviewStatus.Internal_Submitted;
  appStatus = [
    _app.conceptNoteStatus.draft,
    _app.conceptNoteStatus.submitted
  ];
  tagDownloadStatus: any = [
    _app.reviewStatus.Internal_In_Progress,
    _app.reviewStatus.Submitted,
    _app.reviewStatus.Internal_Submitted,
    _app.reviewStatus.In_Progress,
    _app.reviewStatus.COI_Rejected
  ];
  ddConclusion = _app.ddConclusion;
  budgetConclusion = _app.budgetConclusion;
  reviewExternalCompleted: any = _app.reviewStatus.Submitted;
  reviewInternalCompleted: any = _app.reviewStatus.Internal_Submitted;
  rollbackExternalStatus = _app.reviewExternalRollbackStatus;
  rollbackInternalStatus = _app.reviewInternalConceptNoteRollbackStatus;
  dialogConfirm: boolean = false;
  dialogDDRConfirm: boolean = false;
  dialogBudgetConfirm: boolean = false;
  Status: string = "";
  snackColor: string = "";
  snackBar: boolean = false;
  reviewId: any;
  IUCNAdmin = _app.UserType.SystemAdmin;
  logId: number = 0;
  rollbackReason: string = "";
  rollbackDDReason: string = "";
  rollbackBudgetReason: string = "";

  openReview(data) {
    this.$emit("open-review", data);
  }

  showConfirm(id) {
    this.reviewId = id;
    this.dialogConfirm = true;
  }

  showDDRConfirm(id){    
    this.reviewId = id;
    this.dialogDDRConfirm = true;
  }

  showBudgetConfirm(id){
    this.reviewId = id;
    this.dialogBudgetConfirm = true;
  }

  close() {
    this.dialogConfirm = false;
    this.dialogDDRConfirm = false;
    this.dialogBudgetConfirm = false;
    this.logId = 0;
    this.rollbackReason = "";
    this.rollbackDDReason = "";
    this.rollbackBudgetReason = "";
  }

  changeStatus(entity, type){ 
    let id = this.reviewId;
    let reasonRollBack = "";
    let message = this.$services.format.personalizeString(
      `${this.$t("isRequired")}`,
      ["Comment"]
    );
    if(entity == "external"){
      if (!this.rollbackReason) {
        this.notify({ text: message, isHtml: false, color: "error" });
        }else{
        this.$services.review.rollbackReview(id, this.rollbackReason).then(resp => {
        this.snackBar = true;
            if (resp.Result === "OK") {
                this.Status = resp.Message;
                this.snackColor = "green";                        
            } else {
              this.Status = resp.Message;
              this.snackColor = "red";
            }  
            this.rollbackReason = ""; 
            this.dialogConfirm = false;         
            this.$emit("changeStatus");                   
        });
      } 
    }
    else{
      reasonRollBack = type == 'dueDiligence' ? this.rollbackDDReason : this.rollbackBudgetReason;     
      
      if (!reasonRollBack) {
      this.notify({ text: message, isHtml: false, color: "error" });
      }else{
        this.$services.reviewinternal.rollbackReview(id, type, reasonRollBack).then(resp => {
        this.snackBar = true;
            if (resp.Result === "OK") {
                this.Status = resp.Message;
                this.snackColor = "green";                        
            } else {
              this.Status = resp.Message;
              this.snackColor = "red";
            }      
            this.rollbackDDReason = "";   
            this.rollbackBudgetReason = "";
            this.dialogDDRConfirm = false;  
            this.dialogBudgetConfirm = false;      
            this.$emit("changeStatus");                   
        }); 
      }
    }      
  }

  reviewApplication(data) {
    this.$emit("review-app", data);
  }

  downloadPdf(data) {
    this.$emit("download-review", data);
  }

  download(item: any, context: string) {
    const self = this;
    var lang=null;
    let tmp = item.template
      .reduce((obj: any, tmpl: any) => {
          lang=tmpl.Key
          obj[tmpl.Key] = tmpl.Value;
          return obj;
      }, {});
    let template = tmp[lang].properties[context];
    switch (context) {
      case 'dueDiligence':
        this.$services.dueDeligancePdf.print(
          template.properties,
          item.data,
          {...self.appInfo,ApplicationId:self.appInfo.ConceptNoteId} ,
          {
            userInfo: {
              userName: this._username,
              updatedUserDd:item['UserName']?item['UserName']:"",
            },
            modifiedAt: self.formattedDate(item.data.auditInfo.updatedDate)
          });
        break;
    
      case 'budget':
        this.$services.budgetAssessmentPdf.print(
          template,
          item.data,
          {
            userInfo: {
              userName: this._username,
              updatedUserBa:item['UserName']?item['UserName']:"",
            },
            modifiedAt: self.formattedDate(item.data.auditInfo.updatedDate)
          },
          {...self.appInfo,ApplicationId:self.appInfo.ConceptNoteId} );
        break;
    }
  }

  /** date conversion */
  formattedDate(value) {
    const date = value.updatedDate ? value.updatedDate : new Date();
    return this.$services.format.formatUTC(date);
  }

  statusText(context, value) {
    const self = this;
    switch (context) {
      case 'dd':
        return self.ddConclusion.find(x => x.value === value) ? self.ddConclusion.find(x => x.value === value).label : "";
        break;
    
      case 'budget':
        return self.budgetConclusion.find(x => x.value === value) ? self.budgetConclusion.find(x => x.value === value).label : "";
        break;
    }
  }
}
